import script from "./DelPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./DelPopup.vue?vue&type=script&setup=true&lang=js"

import "./DelPopup.vue?vue&type=style&index=0&id=3efb1c6f&lang=css"

const __exports__ = script;

export default __exports__